// export const statecityData = {
//   "Andhra Pradesh": [
//     "Visakhapatnam",
//     "Vijayawada",
//     "Guntur",
//     "Nellore",
//     "Kurnool",
//     "Rajahmundry",
//     "Tirupati",
//     "Kadapa",
//   ],
//   "Arunachal Pradesh": [
//     "Itanagar",
//     "Tawang",
//     "Ziro",
//     "Pasighat",
//     "Naharlagun",
//     "Roing",
//     "Bomdila",
//   ],
//   Assam: [
//     "Guwahati",
//     "Dibrugarh",
//     "Silchar",
//     "Tezpur",
//     "Jorhat",
//     "Nagaon",
//     "Tinsukia",
//   ],
//   Bihar: [
//     "Patna",
//     "Gaya",
//     "Bhagalpur",
//     "Muzaffarpur",
//     "Darbhanga",
//     "Purnia",
//     "Katihar",
//   ],
//   Chhattisgarh: ["Raipur", "Bilaspur", "Durg", "Korba", "Bhilai", "Jagdalpur"],
//   Goa: ["Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda"],
//   Gujarat: [
//     "Ahmedabad",
//     "Surat",
//     "Vadodara",
//     "Rajkot",
//     "Bhavnagar",
//     "Jamnagar",
//     "Junagadh",
//   ],
//   Haryana: [
//     "Gurgaon",
//     "Faridabad",
//     "Panipat",
//     "Ambala",
//     "Yamunanagar",
//     "Rohtak",
//     "Hisar",
//   ],
//   "Himachal Pradesh": ["Shimla", "Manali", "Dharamshala", "Solan", "Mandi"],
//   Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Hazaribagh"],
//   Karnataka: [
//     "Bengaluru",
//     "Mysuru",
//     "Mangaluru",
//     "Hubballi",
//     "Davanagere",
//     "Belagavi",
//   ],
//   Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam"],
//   "Madhya Pradesh": [
//     "Bhopal",
//     "Indore",
//     "Gwalior",
//     "Jabalpur",
//     "Ujjain",
//     "Sagar",
//   ],
//   Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad", "Thane"],
//   Manipur: ["Imphal", "Churachandpur", "Thoubal"],
//   Meghalaya: ["Shillong", "Tura", "Nongpoh"],
//   Mizoram: ["Aizawl", "Lunglei", "Saiha"],
//   Nagaland: ["Kohima", "Dimapur", "Mokokchung"],
//   Odisha: ["Bhubaneswar", "Cuttack", "Rourkela", "Sambalpur", "Puri"],
//   Punjab: ["Amritsar", "Ludhiana", "Patiala", "Jalandhar", "Bathinda"],
//   Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer", "Bikaner"],
//   Sikkim: ["Gangtok", "Namchi"],
//   "Tamil Nadu": [
//     "Chennai",
//     "Coimbatore",
//     "Madurai",
//     "Tiruchirappalli",
//     "Salem",
//     "Tirunelveli",
//   ],
//   Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Khammam"],
//   Tripura: ["Agartala", "Udaipur", "Dharmanagar"],
//   "Uttar Pradesh": [
//     "Lucknow",
//     "Kanpur",
//     "Varanasi",
//     "Agra",
//     "Meerut",
//     "Prayagraj",
//   ],
//   Uttarakhand: ["Dehradun", "Haridwar", "Roorkee", "Haldwani"],
//   "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Siliguri", "Asansol"],
//   Delhi: ["New Delhi", "Dwarka", "Karol Bagh", "Saket", "Rohini"],
//   "Jammu and Kashmir": [
//     "Srinagar",
//     "Jammu",
//     "Anantnag",
//     "Baramulla",
//     "Udhampur",
//   ],
//   Ladakh: ["Leh", "Kargil"],
//   Puducherry: ["Pondicherry", "Karaikal", "Yanam", "Mahe"],
//   Chandigarh: ["Chandigarh"],
//   Lakshadweep: ["Kavaratti", "Agatti", "Minicoy"],
//   "Andaman and Nicobar Islands": [
//     "Port Blair",
//     "Havelock Island",
//     "Car Nicobar",
//     "Diglipur",
//   ],
//   "Dadra and Nagar Haveli and Daman and Diu": ["Silvassa", "Daman", "Diu"],
// };

export const statecityData = [
  { name: "Andhra Pradesh", iso2: "AP" },
  { name: "Arunachal Pradesh", iso2: "AR" },
  { name: "Assam", iso2: "AS" },
  { name: "Bihar", iso2: "BR" },
  { name: "Chhattisgarh", iso2: "CT" },
  { name: "Goa", iso2: "GA" },
  { name: "Gujarat", iso2: "GJ" },
  { name: "Haryana", iso2: "HR" },
  { name: "Himachal Pradesh", iso2: "HP" },
  { name: "Jharkhand", iso2: "JH" },
  { name: "Karnataka", iso2: "KA" },
  { name: "Kerala", iso2: "KL" },
  { name: "Madhya Pradesh", iso2: "MP" },
  { name: "Maharashtra", iso2: "MH" },
  { name: "Manipur", iso2: "MN" },
  { name: "Meghalaya", iso2: "ML" },
  { name: "Mizoram", iso2: "MZ" },
  { name: "Nagaland", iso2: "NL" },
  { name: "Odisha", iso2: "OR" },
  { name: "Punjab", iso2: "PB" },
  { name: "Rajasthan", iso2: "RJ" },
  { name: "Sikkim", iso2: "SK" },
  { name: "Tamil Nadu", iso2: "TN" },
  { name: "Telangana", iso2: "TG" },
  { name: "Tripura", iso2: "TR" },
  { name: "Uttar Pradesh", iso2: "UP" },
  { name: "Uttarakhand", iso2: "UK" },
  { name: "West Bengal", iso2: "WB" },
  { name: "Andaman and Nicobar Islands", iso2: "AN" },
  { name: "Chandigarh", iso2: "CH" },
  { name: "Dadra and Nagar Haveli and Daman and Diu", iso2: "DN" },
  { name: "Delhi", iso2: "DL" },
  { name: "Jammu and Kashmir", iso2: "JK" },
  { name: "Ladakh", iso2: "LA" },
  { name: "Lakshadweep", iso2: "LD" },
  { name: "Puducherry", iso2: "PY" },
];
